import Menu from "./Menu";
import { beveragesMenu } from "../mock";

export default function BeveragesMenu() {
  return (
    <Menu
      menuData={beveragesMenu}
      title="BEVERAGES"
      subtitle="Specialty Coffee | Fine Teas | Shakes & Iced Drinks"
      showTableMenuDownload
      downloadMenuUrl="/image/siteimages/beveragemenu/download/Sea%20Spice%20Kitchen%20-%20Beverages%20Menu%20A4%20(HD%20Print).pdf"
      downloadLabel="Download Beverages Menu (PDF)"
      heroImage="/image/siteimages/gallery/restaurantPhotos/Photo%203.png"
      categoryNotes={{ "Milk Shakes": "Flavours: Banana · Chocolate · Vanilla · Strawberry · Caramel" }}
    />
  );
}
